// extracted by mini-css-extract-plugin
module.exports = {"newsThumb":"NewsThumb_newsThumb__3tn0n","title":"NewsThumb_title__3b0Tu","date":"NewsThumb_date__1p8C3","author":"NewsThumb_author__3zzBk","name":"NewsThumb_name__2IRq1"};